import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { format } from "date-fns"
import server from "server/serverController2"

import CalendarHeader from "components/presenters/calendar/CalenderHeader"
import CalendarBody from "components/presenters/calendar/CalendarBody"
import { removeItem } from "utils/utils"

export default function Calendar({
  selectDay,
  setSelectDay,
  deletedTodoListItem,
  setDeletedTodoListItem,
  userNo,
}) {
  const MAX_STICKER_NUM = 9
  //CaledatDateState
  const [currDate, setCurrDate] = useState(new Date())
  const [currDateList, setCurrDateList] = useState([])
  const [totalDateList, setTotalDateList] = useState([])
  const [startDateIndex, setStartDateIndex] = useState(0)
  const [endDateIndex, setEndDateIndex] = useState(0)
  //CollectionState
  const [collections, setCollections] = useState([])
  //TaskRateState
  const [taskRates, setTaskRates] = useState(null)

  const checkIsToday = (date) => {
    return format(new Date(), "yyyy-MM-dd") === date
  }

  const checkIsOpenTodoList = () => {
    return selectDay?.length !== 0 && ![null, undefined].includes(selectDay) ? true : false
  }

  const calcNextMonth = (date) => {
    const nextMonth = new Date(date)
    nextMonth.setDate(1)

    if (nextMonth.getMonth() === 11) {
      nextMonth.setFullYear(nextMonth.getFullYear() + 1)
      nextMonth.setMonth(0)
      nextMonth.setDate(1)
    } else {
      nextMonth.setMonth(nextMonth.getMonth() + 1)
    }

    return nextMonth
  }

  const calcPrevMonth = (date) => {
    const prevMonth = new Date(date)

    if (prevMonth.getMonth() === 0) {
      prevMonth.setFullYear(prevMonth.getFullYear() - 1)
      prevMonth.setMonth(11)
    } else {
      prevMonth.setMonth(prevMonth.getMonth() - 1)
    }
    return prevMonth
  }

  const handleClickNextDate = () => {
    const nextDate = calcNextMonth(currDate)
    setCurrDate(nextDate)
  }

  const handleClickPrevDate = () => {
    const prevMonth = calcPrevMonth(currDate)
    setCurrDate(prevMonth)
  }

  const dateFormat = (year, month, date) => {
    return format(new Date(year, month, date), "yyyy-MM-dd")
  }

  const getPrevMonthList = (prevDate) => {
    const year = prevDate.getFullYear()
    const prevMonth = prevDate.getMonth()
    const prevMonthLastDate = prevDate.getDate()
    const prevMonthLastDay = prevDate.getDay()

    const prevDateList = []
    if (prevMonthLastDay !== 6) {
      for (let i = 0; i < prevMonthLastDay + 1; ++i) {
        const formatPrevDate = dateFormat(year, prevMonth, prevMonthLastDate - i)
        prevDateList.unshift(formatPrevDate)
      }
    }
    return prevDateList
  }

  const getCurrMonthList = (currDate) => {
    const year = currDate.getFullYear()
    const currMonth = currDate.getMonth()
    const currLastDate = currDate.getDate()

    const currDateList = []
    for (let i = 1; i < currLastDate + 1; ++i) {
      const formatCurrDate = dateFormat(year, currMonth, i)
      currDateList.push(formatCurrDate)
    }
    return currDateList
  }

  const getNextMonthList = (currDate) => {
    const nextDate = calcNextMonth(currDate)

    const year = nextDate.getFullYear()
    const currMonth = nextDate.getMonth()
    const currLastDay = currDate.getDay()

    const nextDateList = []
    for (let i = 1; i < 7 - currLastDay; ++i) {
      const formatNextDate = dateFormat(year, currMonth, i)
      nextDateList.push(formatNextDate)
    }

    return nextDateList
  }

  const renderCalendar = () => {
    const prevMonthLast = new Date(currDate.getFullYear(), currDate.getMonth(), 0)
    const currMonthLast = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 0)

    const prevDateList = getPrevMonthList(prevMonthLast)
    const currDateList = getCurrMonthList(currMonthLast)
    const nextDateList = getNextMonthList(currMonthLast)

    setCurrDateList(currDateList)
    setTotalDateList([...prevDateList, ...currDateList, ...nextDateList])
  }

  const checkSelectDay = (date) => {
    return format(selectDay, "yyyy-MM-dd") === date
  }

  const moveToCalendar = (date) => {
    const selectDate = new Date(date)
    setCurrDate(selectDate)
  }

  const handleClickDate = (date) => {
    if (selectDay) {
      if (checkSelectDay(date)) {
        setSelectDay(null)
        return
      }
    }
    moveToCalendar(date)
    setSelectDay(new Date(date))
  }

  const spliceStickerFor = (stickers) => {
    for (let i = 0; i < stickers.length; ++i) {
      if (stickers[i].stickers.length > MAX_STICKER_NUM) {
        stickers[i].stickers = stickers[i].stickers.slice(0, 9)
      }
    }

    return stickers
  }

  const formatTaskRate = (taskRates) => {
    const dayByTaskRate = {}
    for (let i = 0; i < taskRates.length; ++i) {
      dayByTaskRate[taskRates[i].date] = [
        { rate: taskRates[i].rate },
        { rate: 100 - taskRates[i].rate },
      ]
    }
    return dayByTaskRate
  }

  const handleStickerData = async () => {
    try {
      const stickerCollections = await reqCollectionData()

      setCollections(spliceStickerFor(stickerCollections))
    } catch (err) {
      console.log(err)
    }
  }

  const updateStickerData = async (taskDate) => {
    const collection = await reqCollectionData(taskDate, taskDate)

    const copyCollection = collections.slice()

    for (let i = 0; i < copyCollection.length; ++i) {
      if (copyCollection[i].date === taskDate) {
        if (collection.length === 0) {
          const reloadCollections = removeItem(copyCollection, i)
          setCollections(reloadCollections)
          return
        }
        copyCollection[i] = collection[0]
        break
      }
    }
    setCollections(copyCollection)
  }

  const handleTaskRateData = async () => {
    try {
      const taskRates = await reqTaskRateData()

      setTaskRates(formatTaskRate(taskRates))
    } catch (err) {
      console.log(err)
    }
  }

  const updateTaskRateData = async (taskDate) => {
    const response = await server.getRequestData(
      `users/${userNo}/rate?start_date=${taskDate}&end_date=${taskDate}&type=day`
    )

    if (response.success !== 1) {
      return
    }

    const jsonData = response.data
    const taskRate = jsonData.task_rate

    const copyTaskRates = Object.assign({}, taskRates)

    if (copyTaskRates[taskDate]) {
      copyTaskRates[taskDate] = formatTaskRate(taskRate)[taskDate]
    }
    setTaskRates(copyTaskRates)
  }

  const reqCollectionData = async (
    startDate = currDateList[0],
    endDate = currDateList[currDateList.length - 1]
  ) => {
    try {
      const response = await server.getRequestData(
        `users/${userNo}/stickers/collections?grouping=day&date_ge=${startDate}&date_le=${endDate}`
      )

      if (response?.success !== 1) {
        return
      }

      const jsonData = response?.data
      const collections = jsonData.collections

      return collections
    } catch (err) {
      console.log(err)
    }
  }

  const reqTaskRateData = async (
    startDate = currDateList[0],
    endDate = currDateList[currDateList.length - 1]
  ) => {
    try {
      const response = await server.getRequestData(
        `users/${userNo}/rate?start_date=${startDate}&end_date=${endDate}&type=day`
      )
      //users/:userNo/rate?start_date=2022-01-01&end_date=2022-01-31&type=day
      if (response?.success !== 1) {
        return
      }

      const jsonData = response?.data
      const taskRates = jsonData.task_rate

      return taskRates
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    renderCalendar()
  }, [])

  useEffect(() => {
    if (currDateList.length !== 0) {
      handleStickerData()
      handleTaskRateData()
    }
  }, [currDateList])

  useEffect(() => {
    renderCalendar()
  }, [currDate])

  useEffect(() => {
    if (currDateList.length !== 0 && totalDateList.length !== 0) {
      const lastDateIdx = totalDateList.indexOf(currDateList[0])
      const firstDateIdx = totalDateList.indexOf(currDateList[currDateList.length - 1])

      setStartDateIndex(lastDateIdx)
      setEndDateIndex(firstDateIdx)
    }
  }, [currDateList, totalDateList])

  useEffect(async () => {
    if (deletedTodoListItem !== null) {
      const deleteTaskDate = format(new Date(deletedTodoListItem), "yyyy-MM-dd")
      await updateStickerData(deleteTaskDate)
      await updateTaskRateData(deleteTaskDate)
      setDeletedTodoListItem(null)
    }
  }, [deletedTodoListItem])

  return (
    <>
      <CalendarHeader
        currDate={format(currDate, "yyyy-MM")}
        onClickNext={handleClickNextDate}
        onClickPrev={handleClickPrevDate}
        selectDay={selectDay}
      />
      <CalendarBody
        totalDateList={totalDateList}
        startDateIndex={startDateIndex}
        endDateIndex={endDateIndex}
        collections={collections}
        handleClickDate={handleClickDate}
        selectDay={selectDay}
        taskRates={taskRates}
        checkIsToday={checkIsToday}
        checkIsOpenTodoList={checkIsOpenTodoList}
      />
    </>
  )
}
